import React from 'react';
import MultiProfilePage from '@techsoftware/happay-widgets/MultiprofilePage';
import PropTypes from 'prop-types';
import history from '../../utils/history';
import { takeToDashboard, isMobile } from '../../utils/common/index';

export default class multiProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { loginInfo } = this.props;
    if (!loginInfo.value) {
      history.push('/login');
    }
    takeToDashboard();
  }

  onSignIn = value => {
    this.props.onProfileSelect(value);
  };

  render() {
    const {
      userProfiles,
      loginInfo,
      productLogo,
      privacyPolicyUrl,
      termOfUseUrl,
    } = this.props;

    return (
      <MultiProfilePage
        containerClassName="signin-container"
        logo={productLogo}
        onClickBack={() => {
          history.goBack();
        }}
        userProfiles={userProfiles}
        onSignIn={this.onSignIn}
        // breakPoints={breakPoints}
        profileConfig={{
          orgName: true,
          org: true,
        }}
        data={loginInfo}
        privacyPolicyUrl={privacyPolicyUrl}
        termOfUseUrl={termOfUseUrl}
        privacyPolicyText="Privacy Policy"
        termOfUseText="Terms of Use"
        // multiProfileHeader={i18n.t("logIn.chooseAProfile")}
        // backButtonText={i18n.t("btn.back")}
      />
    );
  }
}

multiProfilePage.propTypes = {
  onProfileSelect: PropTypes.func,
  productLogo: PropTypes.node,
  privacyPolicyUrl: PropTypes.string,
  termOfUseUrl: PropTypes.string,
  userProfiles: PropTypes.array,
  loginInfo: PropTypes.object,
};

multiProfilePage.defaultProps = {};
